// extracted by mini-css-extract-plugin
module.exports = {"Essentials":"Essentials_Essentials__o7a73"};